import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const CoursesIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 29.8 27.4"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 27.4)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
    >
      <g transform="translate(-.83 -.68)">
        <circle cx="23.46" cy="21.02" r="6.1" />
        <g stroke={color ?? svgProps.stroke ?? "currentColor"}>
          <circle cx="23.46" cy="21.02" r="5.2" strokeWidth="2" />
          <path d="m21.8 21h3.4" strokeLinecap="round" strokeWidth="1.5" />
          <path d="m23.5 19.3v3.5" strokeLinecap="round" strokeWidth="1.5" />
        </g>
      </g>
      <g transform="translate(.29 -4.86)">
        <circle cx="2.41" cy="7.56" r=".4" />
        <circle
          cx="2.41"
          cy="7.56"
          r="1.3"
          stroke={color ?? svgProps.stroke ?? "currentColor"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <circle cx="2.41" cy="15.16" r=".4" />
        <circle
          cx="2.41"
          cy="15.16"
          r="1.3"
          stroke={color ?? svgProps.stroke ?? "currentColor"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <circle cx="2.41" cy="22.76" r=".4" />
        <g
          stroke={color ?? svgProps.stroke ?? "currentColor"}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        >
          <circle cx="2.41" cy="22.76" r="1.3" />
          <path d="m8.1 7.7h13.5" />
          <path d="m8.1 15.3h13.5" />
          <path d="m8.1 22.9h4.9" />
        </g>
      </g>
    </SVG>
  );
};
